module.exports = __webpack_public_path__ + "img/lincplus_06.fc4f13ff.png";